/** The `pickers` area: the people, group, tag and view pickers. Owned by the
 *  stage 2 slot components-a (docs/I18N.md §11). */
export const pickers = {
  // The people-and-groups picker, and its form-row field.
  'pickers.entity.placeholder': 'Search people and groups…',
  'pickers.entity.label': 'Search people and groups to add',
  'pickers.entity.empty': 'No matches.',
  'pickers.field.placeholder': 'Anyone',
  'pickers.field.clear': 'Clear {label}',
  // The tag picker.
  'pickers.tag.label': 'Find or create a tag',
  'pickers.tag.placeholder': 'Find or create a tag…',
  'pickers.tag.list': 'Tags',
  'pickers.tag.loading': 'Loading tags…',
  'pickers.tag.empty': 'Type a tag.',
  'pickers.tag.create': 'Create #{tag}',
  /** A tag's quiet adoption line: how many items carry it ... */
  'pickers.tag.onItems': { one: 'on {count} item', other: 'on {count} items' },
  /** ... and, past one, across how many groups. */
  'pickers.tag.withTeams': { one: '{items} · {count} team', other: '{items} · {count} teams' },
} as const;
